<template>
    <div>
        <AGISHeader title="High Mast Lighting System" :subMenuItems="subMenuItems" :helpVisible="false"/>
        <AGISRouteView :subMenuItems="subMenuItems" ref="agis-route-view"/>
    </div>
</template>

<script>
import AGISHeader from '@/components/ui-components/AGISHeader';
import AGISRouteView from '@/components/ui-components/AGISRouteView';

export default {
    name: 'high-mast-lighting-area',
    components: {
        AGISHeader,
        AGISRouteView,
    },
    created: function () {
    },
    data: function() {
        return {
            showSidePanel: true,
            subMenuItems: [
                {
                    routeName: 'Home',
                    title: ' Home'
                },
                {
                    routeName: 'High Mast Lighting Welcome',
                    title: ' Welcome'
                },
                {
                    routeName: 'HMLNetwork',
                    title: ' Network'
                },
                {
                    routeName: 'Lux Measurement',
                    title: ' Lux Measurement'
                },
                {
                    routeName: 'Power Source',
                    title: ' Power Source'
                },
                {
                    routeName: 'Aircraft Earth Receptacle',
                    title: ' Aircraft Earth Receptacle'
                },
                {
                    routeName: 'HMLAAMSAsset',
                    title: ' AAMS Asset'
                },


            ]
        }
    },
    methods: {
    }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/high-mast-lighting-area/Layout.vue